import merge from "lodash/merge";
import BaseChartSeries from "./baseSeries";
import { HlcAreaSeries as CustomHlcAreaSeries } from "../customSeries/hlcAreaSeries/hlcAreaSeries";
import { defaultOptions, HlcAreaSeriesOptions } from '../customSeries/hlcAreaSeries/options'
import { HlcAreaData } from "../customSeries/hlcAreaSeries/data";

class HlcAreaSeries extends BaseChartSeries<HlcAreaData, HlcAreaSeriesOptions> {

    customPaneView?: CustomHlcAreaSeries<HlcAreaData>

    init() {
        this.customPaneView = new CustomHlcAreaSeries();
    }

    addSeriesToChart() {
        return this.chart.chartApi.addCustomSeries(this.customPaneView!, this.seriesOptions)
    }
    
    getDefaultOptions(): HlcAreaSeriesOptions {
        return merge(defaultOptions, this.options)
    }
}

export default HlcAreaSeries;